import StorboltHeader from "components/partials/header";
import StorboltFooter from "components/partials/footer";
import StorboltSidebar from "components/partials/sidebar";
import React from "react";
import { useConfig } from "hooks/use-config";

export default function MainLayout({children}: { children: React.ReactNode }) {
    const [config, setConfig] = useConfig();
    return (
        <main>
            <StorboltSidebar/>
            <StorboltHeader/>
            <div
                className={`lg:p-10 p-4 bg-background overflow-y-scroll no-scrollbar pb-7 ${config.collapsed ? 'lg:ml-16' : 'lg:w-[calc(100%-248px)] lg:ml-[248px]'}`}>
                {children}
            </div>
            <StorboltFooter/>
        </main>
    )
}